import { siteCanonicalUrl, valoresPath } from '../siteDestinations'

/**
 * Metadados e ficha JSON-LD da página /valores/ (quanto custa cada caminho).
 * Página de conversão: título natural, sem palavra de busca própria. As
 * perguntas precisam bater com os títulos visíveis em ValoresPage.tsx (teste).
 * A ficha não publica preço: o valor aparece só no texto da página.
 */

export const valoresTitle = 'Quanto custa o acompanhamento individual | Oficina IA'
export const valoresDescription =
  'Acompanhamento individual com valor combinado na primeira conversa gratuita. Entenda as 9 horas pagas, os custos das ferramentas e o canal gratuito.'

export const valoresFaqItems = [
  {
    question: 'Posso começar sem pagar nada?',
    answer: 'Sim. As aulas do canal são gratuitas, e a primeira conversa de 30 minutos também. Você conhece meu jeito de ensinar antes de decidir se quer companhia.',
  },
  {
    question: 'As assinaturas das ferramentas entram no valor?',
    answer: 'Não. Assinaturas de ferramentas são por conta do participante. O acompanhamento inclui os encontros, dúvidas pelo WhatsApp entre eles e os materiais que eu enviar.',
  },
  {
    question: 'Quanto custa o acompanhamento individual?',
    answer: 'O valor e a distribuição das 9 horas pagas são combinados na primeira conversa, que é gratuita e não faz parte dessas horas. Você conhece as condições antes de decidir continuar.',
  },
  {
    question: 'A Oficina IA emite nota fiscal?',
    answer: 'Sim. A empresa responsável está identificada no rodapé do site e emite nota fiscal de tudo o que você pagar.',
  },
] as const

const valoresUrl = `${siteCanonicalUrl}${valoresPath}`
const organizationId = `${siteCanonicalUrl}/#organization`
const websiteId = `${siteCanonicalUrl}/#website`
const shareImageUrl = `${siteCanonicalUrl}/assets/share/oficina-ia-1200x630.png`

export const valoresStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${valoresUrl}#webpage`,
      url: valoresUrl,
      name: valoresTitle,
      description: valoresDescription,
      inLanguage: 'pt-BR',
      isPartOf: { '@id': websiteId },
      about: { '@id': organizationId },
      primaryImageOfPage: shareImageUrl,
    },
    {
      '@type': 'FAQPage',
      '@id': `${valoresUrl}#faq`,
      mainEntity: valoresFaqItems.map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: { '@type': 'Answer', text: item.answer },
      })),
    },
  ],
} as const

export function valoresStructuredDataScript(): string {
  const json = JSON.stringify(valoresStructuredData).replace(/</g, '\\u003c')
  return `<script type="application/ld+json">${json}</script>`
}
